module.exports = __webpack_public_path__ + "img/baby_spirits_tab.7404f410.png";